/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";
import constants from "../../../helper/constants";
import BusApiCall from "../../../helper/axios.js";

//dialog imports
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";

import InputAdornment from "@mui/material/InputAdornment";
import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import classes from "./customers.module.css";
import FormControl from "@mui/material/FormControl";
import InputPhone from "../../../component/inputPhone";
import stateCode from "../../../helper/stateCode";
import Radio from "@mui/material/Radio";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import { OutlinedInput } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Draggable from "react-draggable";
import { Paper, Tooltip } from "@mui/material";
import { getStatesList } from "../../../helper/getStateList.js";
import actionTypes from "../../../store/actions.js";
import Loader from "../../../component/loader/index.js";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { makeStyles } from '@mui/styles';

const AddChildItemDialog = (props) => {
  const t = props.t;
  const dialogWidth = 500;
  const dialogHeight = 200;

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 300,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '40vw',
  //     },
  // });

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [details, setDetails] = useState({
    isGroup: true,
    partyType: "",
    partyName: "",
    partyRole: "",
    createdByUser: "",
  });

  const [contactDetails, setContactDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const [shippingDetails, setShippingDetails] = useState({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
    country: props.defaultCountry,
  });

  const [locationDetails, setLocationDetails] = useState({
    identifier: "",
    description: "",
    positioning: "",
  });

  const [isEditMode, setMode] = useState(false);
  const [addShippingAddress, setAddShippingAddress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partialLoading, togglePartialLoading] = useState(false);

  const validateDetails = () => {
    const error = {};
    if (!isEditMode) {
      if (!details.partyType) {
        error.partyType = t("USER_TYPE_IS_REQUIRED");
      }
      if (details.partyType !== "PARTY_GROUP") {
        setDetails({
          ...details,
          isGroup: false,
        });
      }
    }
    if (details.partyType === "LOCATION") {
      if (!details.partyName || details.partyName.trim() === "") {
        error.name = t("NAME_IS_REQUIRED");
      }
      setDetails({
        ...details,
        partyRole: "",
      });
      setIsAdmin(false);
      setAllowLogin(false);
      setError(error);
      if (Object.keys(error).length === 0) {
        return true;
      }
    } else {
      if (!details.partyName || details.partyName.trim() === "") {
        error.name = t("NAME_IS_REQUIRED");
      }
      // if (!contactDetails.firstName) {
      //     error.firstName = t('FIRST_NAME_IS_REQUIRED');
      // }
      // if (!contactDetails.lastName) {
      //     error.lastName = t('LAST_NAME_IS_REQUIRED');
      // }
      if (!contactDetails.email) {
        error.email = t("EMAIL_IS_REQUIRED");
      } else if (!/\S+@\S+\.\S+/.test(contactDetails.email)) {
        error.email = t("EMAIL_IS_INVALID");
      }
      if (contactDetails.phone) {
        if (!validateMobileNumber(contactDetails.phone)) {
          error.phone = t("PHONE_IS_INVALID");
        }
      }

      if (addShippingAddress) {
        if (!shippingDetails.addressLine1) {
          error.addressLine1 = t("STREET1_IS_REQUIRED");
        }
        if (!shippingDetails.city) {
          error.city = t("CITY_IS_REQUIRED");
        }
        // if (!shippingDetails.zipCode) {
        //     error.zipCode = t('ZIP_IS_REQUIRED');
        // }
        if (!shippingDetails.state) {
          error.state = t("STATE_IS_REQUIRED");
        }
        if (!shippingDetails.country) {
          error.country = t("COUNTRY_IS_REQUIRED");
        }
      }
      if (allowLogin) {
        if (!loginData.id || loginData.id.trim() === "") {
          error.id = t("USERNAME_IS_REQUIRED");
        }
        if (isPasswordRequired === "true") {
          if (!loginData.password) {
            error.password = t("PASSWORD_IS_REQUIRED");
          }
          // else if (loginData.password.length < 6){
          //     error.password = t('PASSWORD_LENGTH_ERROR');
          // }
          if (!loginData.repeatPassword) {
            error.repeatPassword = t("CONFIRM_PASSWORD_IS_REQUIRED");
          } else if (loginData.password !== loginData.repeatPassword) {
            error.repeatPassword = t("PASSWORD_MISMATCH_ERROR");
          }
        }
      }
      if (details.partyType === "PARTY_GROUP") {
        setDetails({
          ...details,
          partyRole: "",
        });
        setIsAdmin(false);
        setAllowLogin(false);
      }
      setError(error);
      // if (!details.partyName || !contactDetails.firstName ||
      //     !contactDetails.lastName || !contactDetails.email) {

      // setDataError({
      //     ...dataError,
      //     show: true
      // })
      if (Object.keys(error).length === 0) {
        return true;
      }
    }
  };

  const [isPasswordRequired, setIsPasswordRequired] = useState("true");
  //const [isManagedRequired, setIsManagedRequired] = useState('true');
  const [disableUsername, setDisabledUsername] = useState(false);

  useEffect(() => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_PARTY_CONFIGS/endpoint`,
      {},
    ).then((res) => {
      let isPasswordRequired = res.data["party.login.password.required"]
        ? res.data["party.login.password.required"]
        : "true";
      //let isManagedRequired = res.data['party.managed.enabled'] ? res.data['party.managed.enabled'] : 'true';
      //console.log('check val', isPasswordRequired, isManagedRequired)
      setIsPasswordRequired(isPasswordRequired);
      //setIsManagedRequired(isManagedRequired)
    });
    if (props.editData && props.editData.partyId) {
      if (props.editData.userName) {
        setLoginData({
          ...loginData,
          id: props.editData.userName,
        });
        setDisabledUsername(true);
      }
      setMode(true);
      setDetails({
        ...details,
        isGroup: props.editData.isGroup,
        partyName: props.editData.partyName,
        partyId: props.editData.partyId,
        parentPartyId: props.editData.parentPartyId,
        userName: props.editData.userName,
        partyType: props.editData.partyType,
        createdByUser: props.editData.createdByUser || props.loggedInUserId,
        //isManaged: props.editData.isManaged
      });
      if (props.editData.partyType === "LOCATION") {
        setLocationDetails({
          ...locationDetails,
          ...props.editData.locationDetails,
        });
      } else {
        setContactDetails({
          ...contactDetails,
          ...props.editData.contact,
        });
        setShippingDetails({
          ...shippingDetails,
          ...props.editData.shipping,
        });
        if (
          ("addressLine1" in props.editData.shipping &&
            Object.keys(props.editData.shipping.addressLine1).length > 0) ||
          ("city" in props.editData.shipping &&
            Object.keys(props.editData.shipping.city).length > 0) ||
          ("zipCode" in props.editData.shipping &&
            Object.keys(props.editData.shipping.zipCode).length > 0)
        ) {
          setAddShippingAddress(true);
        }
        if (props.editData && props.editData.shipping.country == "") {
          setStateListChange(props.defaultCountry);
          setShippingDetails({
            ...shippingDetails,
            country: props.defaultCountry,
          });
        } else {
          setStateListChange(props.editData.shipping.country);
        }
      }
    } else {
      setMode(false);
      setStateListChange(props.defaultCountry);
    }
  }, []);

  useEffect(() => {
    const centerX = window.innerWidth / 2 - dialogWidth / 2;
    const centerY = window.innerHeight / 2 - dialogHeight / 2;
    setPosition({ x: centerX, y: centerY });
  }, [props.open]);

  const addChildItem = () => {
    if (validateDetails()) {
      // if (validateLoginData()) {
      let data = JSON.parse(JSON.stringify(details));
      if (data.partyType === "PARTY_GROUP") {
        data.isGroup = true;
      } else {
        data.isGroup = false;
      }
      // if (data.partyType === 'PERSON' ){
      //     if (allowLogin && !isAdmin) {
      //             data.partyRole= 'ECOMMERCE_CUSTOMER'
      //     }
      //     else if (allowLogin && isAdmin) {
      //             data.partyRole= 'ECOMMERCE_ADMIN'
      //     }
      //     else if (!allowLogin) {
      //             data.partyRole= ''
      //     }
      // }
      if (details.partyType === "LOCATION") {
        data.locationDetails = { ...locationDetails };
        props.close(data);
      } else {
        data.contact = { ...contactDetails };
        data.shippingAddress = { ...shippingDetails };
        if (!addShippingAddress) {
          data.shippingAddress = {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zipCode: "",
            country: "",
          };
        } else {
          data.shippingAddress = {
            addressLine1: shippingDetails.addressLine1,
            addressLine2: shippingDetails.addressLine2
              ? shippingDetails.addressLine2
              : "",
            city: shippingDetails.city,
            state: shippingDetails.state,
            zipCode: shippingDetails.zipCode,
            country: shippingDetails.country,
          };
        }
        if (allowLogin) {
          var userData = {
            id: loginData.id,
            email: data.contact.email,
            firstname: data.contact.firstName,
            lastname: data.contact.lastName,
            tenantId: props.tenantId,
          };
          if (details.partyType === "PERSON") {
            if (allowLogin && !isAdmin) {
              userData.partyRole = "ECOMMERCE_CUSTOMER";
            } else if (allowLogin && isAdmin) {
              userData.partyRole = "ECOMMERCE_ADMIN";
            } else if (!allowLogin) {
              userData.partyRole = "";
            }
          }
          if (isPasswordRequired === "true") {
            userData.password = loginData.password;
          }
          props.close(data, userData);
        } else {
          props.close(data);
        }
      }
    }
  };

  const [loginDataError, setLoginDataError] = useState({
    show: true,
    message: "",
  });

  // const validateLoginData = () => {
  //     setDataError({
  //         ...dataError,
  //         show: false
  //     })
  //     if (allowLogin) {
  //         if (props.tenantId !== 'spottel') {
  //             if (loginData.password !== loginData.repeatPassword) {
  //                 setLoginDataError({
  //                     show: true,
  //                     message: '"Password" and "Confirm Password" does not match'
  //                 })
  //                 return false;
  //             }
  //             setLoginDataError({
  //                 show: false,
  //                 message: ''
  //             })
  //         }
  //         return true;
  //     }
  //     else {
  //         setLoginDataError({
  //             show: false,
  //             message: ''
  //         })
  //         return true;
  //     }
  // }

  const updateChildItem = () => {
    if (validateDetails()) {
      // if (validateLoginData()) {
      let data = { ...details };
      if (details.partyType === "LOCATION") {
        data.locationDetails = { ...locationDetails };
        props.closeEdit(data);
      } else {
        data.contact = { ...contactDetails };
        //updating the new values in local storage
        var userRoles = JSON.parse(localStorage.getItem("roles"));
        userRoles.data.loggedInUser.email = data.contact.email;
        userRoles.data.loggedInUser.userName =
          data.contact.firstName + " " + data.contact.lastName;
        localStorage.setItem("roles", JSON.stringify(userRoles));
        data.shippingAddress = { ...shippingDetails };
        if (!addShippingAddress) {
          data.shippingAddress = {
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zipCode: "",
            country: "",
          };
        } else {
          data.shippingAddress = {
            addressLine1: shippingDetails.addressLine1,
            addressLine2: shippingDetails.addressLine2
              ? shippingDetails.addressLine2
              : "",
            city: shippingDetails.city,
            state: shippingDetails.state,
            zipCode: shippingDetails.zipCode,
            country: shippingDetails.country,
          };
        }
        if (allowLogin) {
          var userData = {
            id: loginData.id,
            email: data.contact.email,
            firstname: data.contact.firstName,
            lastname: data.contact.lastName,
            tenantId: props.tenantId,
          };
          if (details.partyType === "PERSON") {
            if (allowLogin && !isAdmin) {
              userData.partyRole = "ECOMMERCE_CUSTOMER";
            } else if (allowLogin && isAdmin) {
              userData.partyRole = "ECOMMERCE_ADMIN";
            } else if (!allowLogin) {
              userData.partyRole = "";
            }
          }
          if (isPasswordRequired === "true") {
            userData.password = loginData.password;
          }
          props.closeEdit(data, userData);
        } else {
          props.closeEdit(data);
        }
      }
    }
  };

  const [dataError, setDataError] = useState({
    message: t("MANDATORY_FIELDS_MESSAGE"),
    show: false,
  });
  const [allowLogin, setAllowLogin] = useState(false);
  const allowLoginChange = (value) => {
    setAllowLogin(value);
  };
  const [loginData, setLoginData] = useState({
    id: "",
    password: "",
    repeatPassword: "",
  });
  const changeLoginData = (e) => {
    var tempData = { ...loginData };
    // if (e.target.name === 'id') {
    //     if (e.target.value.includes('@')) {
    //         return;
    //     } else {
    //         tempData[e.target.name] = e.target.value;
    //     }
    // } else {
    tempData[e.target.name] = e.target.value;
    //}
    setLoginData(tempData);
  };

  const mandatoryMessage = {
    color: "#f44336",
    fontSize: "12px",
  };
  const addShippingAddressToggle = (value) => {
    setAddShippingAddress(value);
  };

  const [isAdmin, setIsAdmin] = useState(false);
  const allowAdminToggle = (value) => {
    setIsAdmin(value);
  };

  // const toggleManaged = (value) => {
  //     setDetails({
  //         ...details,
  //         isManaged: value
  //     })
  // }

  const validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(mobileNumber)) {
      return false;
    }
    return true;
  };

  const [error, setError] = useState({});

  const [statesList, setStatesList] = useState([]);
  const setStateListChange = (country) => {
    setLoading(true);
    getStatesList(country)
      .then((res) => {
        setStatesList(res);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("FAILED_TO_LOAD_STATES"), false);
        }
      });
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const handlePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleRepeatPasswordVisibility = () => {
    setShowRepeatPassword((prevShowRepeatPassword) => !prevShowRepeatPassword);
  };

  const verifyUserId = () => {
    const userId = details.createdByUser;
    if (userId) {
      togglePartialLoading(true);
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/users/verify?userId=${userId}`,
        {},
      )
        .then((res) => {
          console.log("check res", res);
          if (res && res.data) {
            if (res.data.userExists) {
              //userId is valid
              props.setErrorMessage(props.t("USER_ID_VERIFIED"), true);
            } else {
              setError({
                ...error,
                createdBy: props.t("INVALID_USER_ID"),
              });
            }
            togglePartialLoading(false);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            props.setErrorMessage(err.response.data.message, false);
          } else {
            props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
          }
          togglePartialLoading(false);
        });
    }
  };
  // const classess = useStyles();
  return (
    <Dialog
      disableScrollLock={true}
      open={props.open}
      PaperComponent={DraggableDialogPaper}
      fullWidth={true}
      maxWidth={"sm"}
      style={{ maxHeight: "90vh" }}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
    >
      <DialogTitle
        id="draggableDialogPaper"
        className="draggableDialogPaper"
        style={{ cursor: "move" }}
      >
        <div style={{ display: "flex" }}>
          <span style={{ display: "inline-flex", width: "95%" }}>
            {isEditMode
              ? t("EDIT") + " :" + details.partyName
              : t("ADD_SUB_CUSTOMER")}
          </span>
          <Tooltip title={t("CLOSE")}>
            <IconButton
              onTouchStart={(event) => props.close()}
              onClick={(event) => props.close()}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </div>
      </DialogTitle>
      {props.err && (
        <div className={classes.errorBanner}>
          <span
            className={classes.errorMessage}
            style={{ color: "color: #D8210E", fontWeight: "600" }}
          >
            {props.err}
          </span>
        </div>
      )}
      <DialogContent dividers style={{ flex: 1, overflow: "auto" }}>
        <Grid container spacing={2}>
          {isEditMode ? (
            !disableUsername &&
            details.partyType === "PERSON" && (
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <div style={{ position: "relative", left: "-.42rem" }}>
                    <Checkbox
                      checked={allowLogin}
                      onChange={() => allowLoginChange(!allowLogin)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          allowLoginChange(!allowLogin);
                        }
                      }}
                    />
                    <span
                      style={{
                        position: "relative",
                        top: "-8px",
                        marginLeft: "5px",
                      }}
                    >
                      {t("ALLOW_LOGIN")}
                    </span>
                  </div>
                </Grid>
                {allowLogin && (
                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <div style={{ position: "relative", left: "-.42rem" }}>
                        <FormControlLabel
                          style={{ marginLeft: "auto", marginRight: "auto" }}
                          control={
                            <Checkbox
                              checked={isAdmin}
                              onChange={() => allowAdminToggle(!isAdmin)}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  allowAdminToggle(!isAdmin);
                                }
                              }}
                            />
                          }
                        />
                        <span
                          style={{
                            position: "relative",
                            marginLeft: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {t("ADMIN")}
                        </span>
                      </div>
                    </Grid>
                  </>
                )}
              </>
            )
          ) : (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <FormControl
                  variant={"outlined"}
                  className="custom-select-input"
                  size={"small"}
                  error={!!error.partyType}
                >
                  <InputLabel htmlFor="partyType">
                    {t("SELECT_USER_TYPE")}
                  </InputLabel>
                  <Select
                    native
                    label={t("SELECT_USER_TYPE")}
                    autoFocus
                    value={details.partyType}
                    onChange={(e) => {
                      setDetails({
                        ...details,
                        [e.target.name]: e.target.value,
                      });
                      setError({
                        //...error,
                        partyType: "",
                      });
                    }}
                    //label="Age"
                    inputProps={{
                      name: "partyType",
                      id: "partyType",
                    }}
                  >
                    <option value="" disabled></option>
                    <option value={"PARTY_GROUP"}>{t("GROUP")}</option>
                    <option value={"PERSON"}>{t("INDIVIDUAL")}</option>
                    {/* <option value={'LOCATION'}>{t('LOCATION')}</option> */}
                  </Select>
                  {error.partyType && (
                    <span
                      style={{
                        color: "#f44336",
                        marginLeft: "0px",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {error.partyType}
                    </span>
                  )}
                </FormControl>
              </Grid>
            </>
          )}
          {details.partyType === "LOCATION" && (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  error={!!error.name}
                  helperText={error.name}
                  inputProps={{
                    maxLength: 100,
                  }}
                  size={"small"}
                  variant={"outlined"}
                  name={"partyName"}
                  value={details.partyName}
                  placeholder={t("NAME_OF_THE_LOCATION") + " *"}
                  onChange={(e) => {
                    setDetails({
                      ...details,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      name: "",
                    });
                  }}
                  onBlur={() => {
                    setDetails({
                      ...details,
                      partyName: details.partyName.trim(),
                    });
                  }}
                />
              </Grid>
            </>
          )}

          {details.partyType === "PERSON" && !disableUsername && (
            <>
              {!isEditMode && (
                <>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <div style={{ position: "relative", left: "-.42rem" }}>
                      <Checkbox
                        checked={allowLogin}
                        onChange={() => allowLoginChange(!allowLogin)}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            allowLoginChange(!allowLogin);
                          }
                        }}
                      />
                      <span
                        style={{
                          position: "relative",
                          top: "-8px",
                          marginLeft: "5px",
                        }}
                      >
                        {t("ALLOW_LOGIN")}
                      </span>
                    </div>
                  </Grid>

                  {allowLogin && (
                    <>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <div style={{ position: "relative", left: "-.42rem" }}>
                          <FormControlLabel
                            style={{ marginLeft: "auto", marginRight: "auto" }}
                            control={
                              <Checkbox
                                checked={isAdmin}
                                onChange={() => allowAdminToggle(!isAdmin)}
                                onKeyDown={(event) => {
                                  if (event.key === "Enter") {
                                    allowAdminToggle(!isAdmin);
                                  }
                                }}
                              />
                            }
                          />
                          <span
                            style={{
                              position: "relative",
                              marginLeft: "5px",
                              fontSize: "14px",
                            }}
                          >
                            {t("ADMIN")}
                          </span>
                        </div>
                      </Grid>
                    </>
                  )}
                </>
              )}

              {/* {isManagedRequired === 'true' &&
                                <Grid item xs={12}>
                                <div style={{ position: 'relative', left: '-.42rem' }}>
                                    <FormControlLabel style={{ marginLeft: 'auto', marginRight: 'auto' }} control={
                                        <Checkbox
                                            checked={details.isManaged}
                                            onChange={() => toggleManaged(!details.isManaged)}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter') {
                                                    toggleManaged(!details.isManaged);
                                                }
                                            }}
                                        />}
                                    />
                                    <span style={{ position: 'relative', marginLeft: '5px', fontSize: '14px' }}>{t('IS_MANAGED')}</span>
                                    </div>
                                </Grid>
                            } */}
            </>
          )}

          {/*If a user has login permission set, they can only view whether they have admin 
                        privilleges but cannot edit it themselves*/}
          {/* {disableUsername && isEditMode && details.partyRole === 'ECOMMERCE_ADMIN' &&
                             <>
                             <FormControlLabel style={{ marginLeft: 'auto', marginRight: 'auto' }} control={
                                     <Checkbox
                                         checked={details.partyRole === 'ECOMMERCE_ADMIN' ? true : false}
                                         disabled={true}
                                     />} 
                                 /> 
                                 <span style={{ position: 'relative', marginLeft: '5px', fontSize: '14px' }}>{t('ADMIN')}</span>
                         </>
                        }
                    </Grid> */}
          {details.partyType === "PARTY_GROUP" && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                error={!!error.name}
                helperText={error.name}
                inputProps={{
                  maxLength: 100,
                }}
                size={"small"}
                variant={"outlined"}
                name={"partyName"}
                value={details.partyName}
                placeholder={t("NAME_OF_THE_GROUP") + " *"}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    [e.target.name]: e.target.value,
                  });
                  setError({
                    ...error,
                    name: "",
                  });
                }}
                onBlur={() => {
                  setDetails({
                    ...details,
                    partyName: details.partyName.trim(),
                  });
                }}
              />
            </Grid>
          )}
          {details.partyType === "PERSON" && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <Input
                error={!!error.name}
                helperText={error.name}
                inputProps={{
                  maxLength: 100,
                }}
                size={"small"}
                variant={"outlined"}
                name={"partyName"}
                value={details.partyName}
                placeholder={t("NAME_OF_THE_INDIVIDUAL") + " *"}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    [e.target.name]: e.target.value,
                  });
                  setError({
                    ...error,
                    name: "",
                  });
                }}
                onBlur={() => {
                  setDetails({
                    ...details,
                    partyName: details.partyName.trim(),
                  });
                }}
              />
            </Grid>
          )}

          {/* Contact details */}
          {(details.partyType === "PERSON" ||
            details.partyType === "PARTY_GROUP") && (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <h3>{t("CONTACT")}</h3>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  error={!!error.firstName}
                  helperText={error.firstName}
                  size={"small"}
                  variant={"outlined"}
                  name={"firstName"}
                  value={contactDetails.firstName}
                  placeholder={t("FIRST_NAME")}
                  onChange={(e) => {
                    setContactDetails({
                      ...contactDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      firstName: "",
                    });
                  }}
                  onBlur={() => {
                    setContactDetails({
                      ...contactDetails,
                      firstName: contactDetails.firstName.trim(),
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  error={!!error.lastName}
                  helperText={error.lastName}
                  size={"small"}
                  variant={"outlined"}
                  name={"lastName"}
                  value={contactDetails.lastName}
                  placeholder={t("LAST_NAME")}
                  onChange={(e) => {
                    setContactDetails({
                      ...contactDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      lastName: "",
                    });
                  }}
                  onBlur={() => {
                    setContactDetails({
                      ...contactDetails,
                      lastName: contactDetails.lastName.trim(),
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <InputPhone
                  error={!!error.phone}
                  helperText={error.phone}
                  size={"small"}
                  variant={"outlined"}
                  name={"phone"}
                  value={contactDetails.phone}
                  placeholder={t("PHONE")}
                  onChange={(e) => {
                    setContactDetails({
                      ...contactDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      lastName: "",
                    });
                  }}
                  onBlur={() => {
                    setContactDetails({
                      ...contactDetails,
                      phone: contactDetails.phone.trim(),
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  error={!!error.email}
                  helperText={error.email}
                  size={"small"}
                  variant={"outlined"}
                  name={"email"}
                  value={contactDetails.email}
                  placeholder={t("EMAIL") + " *"}
                  onChange={(e) => {
                    setContactDetails({
                      ...contactDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      email: "",
                    });
                  }}
                  onBlur={() => {
                    setContactDetails({
                      ...contactDetails,
                      email: contactDetails.email.trim(),
                    });
                  }}
                />
              </Grid>

              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <div style={{ position: "relative", left: "-.42rem" }}>
                  <FormControlLabel
                    style={{ marginLeft: "auto", marginRight: "auto" }}
                    control={
                      <Checkbox
                        checked={addShippingAddress}
                        onChange={() =>
                          addShippingAddressToggle(!addShippingAddress)
                        }
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            addShippingAddressToggle(!addShippingAddress);
                          }
                        }}
                      />
                    }
                  />
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "5px",
                      fontSize: "14px",
                    }}
                  >
                    {t("ADD_SHIPPING_ADDRESS")}
                  </span>
                </div>
              </Grid>

              {addShippingAddress && (
                <>
                  {/* Shipping address */}
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <h3>{t("SHIPPING_ADDRESS")} </h3>
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      error={!!error.addressLine1}
                      helperText={error.addressLine1}
                      size={"small"}
                      variant={"outlined"}
                      name={"addressLine1"}
                      value={shippingDetails.addressLine1}
                      placeholder={t("STREET1") + " *"}
                      onChange={(e) => {
                        setShippingDetails({
                          ...shippingDetails,
                          [e.target.name]: e.target.value,
                        });
                        setError({
                          ...error,
                          addressLine1: "",
                        });
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"addressLine2"}
                      value={shippingDetails.addressLine2}
                      placeholder={t("STREET2")}
                      onChange={(e) => {
                        setShippingDetails({
                          ...shippingDetails,
                          [e.target.name]: e.target.value,
                        });
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      error={!!error.city}
                      helperText={error.city}
                      name={"city"}
                      size={"small"}
                      variant={"outlined"}
                      value={shippingDetails.city}
                      placeholder={t("CITY") + " *"}
                      onChange={(e) => {
                        setShippingDetails({
                          ...shippingDetails,
                          [e.target.name]: e.target.value,
                        });
                        setError({
                          ...error,
                          city: "",
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      error={!!error.zipCode}
                      helperText={error.zipCode}
                      name={"zipCode"}
                      size={"small"}
                      variant={"outlined"}
                      value={shippingDetails.zipCode}
                      placeholder={t("ZIP")}
                      onChange={(e) => {
                        setShippingDetails({
                          ...shippingDetails,
                          [e.target.name]: e.target.value,
                        });
                        setError({
                          ...error,
                          zipCode: "",
                        });
                      }}
                      onBlur={() => {
                        setShippingDetails({
                          ...shippingDetails,
                          zipCode: shippingDetails.zipCode.trim(),
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      className="custom-select-input"
                      size={"small"}
                      error={!!error.country}
                    >
                      <InputLabel htmlFor="selectCountry">
                        {t("SELECT_COUNTRY")}
                      </InputLabel>
                      <Select
                        native
                        label={t("SELECT_COUNTRY")}
                        value={shippingDetails.country}
                        inputProps={{
                          name: "country",
                          id: "country",
                        }}
                        onChange={(e) => {
                          setShippingDetails({
                            ...shippingDetails,
                            [e.target.name]: e.target.value,
                            state: "",
                          });
                          setError({
                            ...error,
                            country: "",
                          });
                          setStateListChange(e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          {t("SELECT_COUNTRY") + " *"}
                        </option>
                        {/* {stateCode.country.map(a => (
                                                    <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                ))} */}
                        {props.countriesList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Select>
                      {error.country && (
                        <span
                          style={{
                            color: "#f44336",
                            marginLeft: "0px",
                            fontSize: "0.75rem",
                            marginTop: "4px",
                          }}
                        >
                          {error.country}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      className="custom-select-input"
                      size={"small"}
                      error={!!error.state}
                    >
                      <InputLabel htmlFor="selectCountry">
                        {t("SELECT_STATE")}
                      </InputLabel>
                      <Select
                        native
                        label={t("SELECT_STATE")}
                        onChange={(e) => {
                          setShippingDetails({
                            ...shippingDetails,
                            [e.target.name]: e.target.value,
                          });
                          setError({
                            ...error,
                            state: "",
                          });
                        }}
                        value={shippingDetails.state}
                        inputProps={{
                          name: "state",
                          id: "state",
                        }}
                      >
                        {/* <option value="" disabled>{t('SELECT_STATE') + ' *'}</option> */}
                        {/* {shippingDetails.country &&
                                                    stateCode.state[shippingDetails.country].map(a => (
                                                        <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                    ))} */}
                        {shippingDetails.country &&
                          statesList.map((a) => (
                            <option key={a.id} value={a.id}>
                              {" "}
                              {a.name}
                            </option>
                          ))}
                      </Select>
                      {error.state && (
                        <span
                          style={{
                            color: "#f44336",
                            marginLeft: "0px",
                            fontSize: "0.75rem",
                            marginTop: "4px",
                          }}
                        >
                          {error.state}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                </>
              )}
            </>
          )}
          {details.partyType === "LOCATION" && (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <h3>{t("INFORMATION")}</h3>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  inputProps={{
                    maxLength: 100,
                  }}
                  size={"small"}
                  variant={"outlined"}
                  name={"identifier"}
                  value={locationDetails.identifier}
                  placeholder={t("IDENTIFIER")}
                  onChange={(e) => {
                    setLocationDetails({
                      ...locationDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      identifier: "",
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  inputProps={{
                    maxLength: 200,
                  }}
                  rows={4}
                  size={"small"}
                  variant={"outlined"}
                  name={"description"}
                  value={locationDetails.description}
                  placeholder={t("DESCRIPTION")}
                  onChange={(e) => {
                    setLocationDetails({
                      ...locationDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      description: "",
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Input
                  inputProps={{
                    maxLength: 100,
                  }}
                  size={"small"}
                  variant={"outlined"}
                  name={"positioning"}
                  value={locationDetails.positioning}
                  placeholder={t("POSITIONING")}
                  onChange={(e) => {
                    setLocationDetails({
                      ...locationDetails,
                      [e.target.name]: e.target.value,
                    });
                    setError({
                      ...error,
                      positioning: "",
                    });
                  }}
                />
              </Grid>
            </>
          )}
          {details.partyType === "PERSON" && allowLogin && (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <h3>{t("LOGIN_CREDENTIALS")}</h3>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  error={!!error.id}
                  helperText={error.id}
                  size={"small"}
                  variant={"outlined"}
                  name="id"
                  placeholder={t("USERNAME") + " *"}
                  onChange={(event) => {
                    changeLoginData(event);
                    setError({
                      ...error,
                      id: "",
                    });
                  }}
                  value={loginData.id}
                  // InputProps={{
                  //     endAdornment: <InputAdornment position="end">@{props.tenantId}.com</InputAdornment>,
                  // }}
                />
              </Grid>
              {isPasswordRequired === "true" && (
                <>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      size={"small"}
                      className="custom-select-input"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        {t("PASSWORD") + " *"}
                      </InputLabel>
                      {!navigator.userAgent.includes("Edg") ? ( //check added incase of MS Edge where it would add a password eye icon by default
                        <OutlinedInput
                          error={!!error.password}
                          id="outlined-adornment-password"
                          // type="password"
                          name="password"
                          value={loginData.password}
                          onChange={(event) => {
                            changeLoginData(event);
                            setError({
                              ...error,
                              password: "",
                            });
                          }}
                          type={showPassword ? "text" : "password"}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handlePasswordVisibility}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      ) : (
                        <OutlinedInput
                          error={!!error.password}
                          id="outlined-adornment-password"
                          // type="password"
                          name="password"
                          value={loginData.password}
                          onChange={(event) => {
                            changeLoginData(event);
                            setError({
                              ...error,
                              password: "",
                            });
                          }}
                          type={showPassword ? "text" : "password"}
                        />
                      )}
                      {error.password && (
                        <span
                          style={{
                            color: "#f44336",
                            marginLeft: "0px",
                            fontSize: "0.75rem",
                            marginTop: "4px",
                          }}
                        >
                          {error.password}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    {!navigator.userAgent.includes("Edg") ? (
                      <Input
                        error={!!error.repeatPassword}
                        helperText={error.repeatPassword}
                        size={"small"}
                        variant={"outlined"}
                        name="repeatPassword"
                        // type="password"
                        placeholder={t("REPEAT_PASSWORD") + " *"}
                        onChange={(event) => {
                          changeLoginData(event);
                          setError({
                            ...error,
                            repeatPassword: "",
                          });
                        }}
                        value={loginData.repeatPassword}
                        type={showRepeatPassword ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleRepeatPasswordVisibility}
                                edge="end"
                              >
                                {showRepeatPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    ) : (
                      <Input
                        error={!!error.repeatPassword}
                        helperText={error.repeatPassword}
                        size={"small"}
                        variant={"outlined"}
                        name="repeatPassword"
                        // type="password"
                        placeholder={t("REPEAT_PASSWORD") + " *"}
                        onChange={(event) => {
                          changeLoginData(event);
                          setError({
                            ...error,
                            repeatPassword: "",
                          });
                        }}
                        value={loginData.repeatPassword}
                        type={showRepeatPassword ? "text" : "password"}
                      />
                    )}
                  </Grid>
                </>
              )}
            </>
          )}
          {disableUsername && (
            <>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <h3>{t("LOGIN_CREDENTIALS")} *</h3>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  name="id"
                  placeholder={t("USERNAME") + " *"}
                  value={loginData.id}
                  disabled={true}
                />
              </Grid>
            </>
          )}
          {/* {(details.partyType === 'PERSON' || details.partyType === 'PARTY_GROUP') && props.showMyCustomers &&
                    <>
                    <Grid item xs={12}>
                        <h3>{t('CREATED_BY')}</h3>
                    </Grid>
                            <Grid item xs={12} md={6}>
                                <Input
                                    error={!!error.createdBy}
                                    helperText={error.createdBy}
                                    size={'small'}
                                    variant={'outlined'}
                                    name={'createdByUser'}
                                    value={details.createdByUser}
                                    placeholder={t('USERNAME') + ' *'}
                                    
                                    disabled={true}
                                />
                            </Grid>
                            </>
                            }    */}
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: dataError.show ? "space-between" : "flex-end",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Grid
            item
            style={{ textAlign: "left" }}
            size={{
              xs: 6,
            }}
          >
            {/* {(dataError.show) ?
                            <span item xs={12} className={classes.errorMessage}>{dataError.message}</span>
                            :
                            <></>
                        } */}
            {/* {(loginDataError.show) ?
                            <span item xs={12} className={classes.errorMessage}>{loginDataError.message}</span>
                            :
                            <></>
                        } */}
            {/* <label style={mandatoryMessage}>
                            {t('MANDATORY_FIELDS_MESSAGE')}
                        </label> */}
          </Grid>
          <Grid item className="text-right">
            {/* <Button onClick={event => props.close()} color="primary" style={{ marginRight: '10px' }}>{t('CANCEL')}</Button> */}
            {isEditMode ? (
              <Button
                onClick={() => {
                  updateChildItem();
                }}
                color="primary"
              >
                {t("UPDATE")}
              </Button>
            ) : (
              <Button
                onClick={() => {
                  addChildItem();
                }}
                color="primary"
              >
                {t("ADD")}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogActions>
      <Loader loading={loading} />
      <Loader loading={partialLoading} />
    </Dialog>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantId: state.auth.tenantId,
    countriesList: state.global.countriesList,
    tenantData: state.auth.tenantData,
    defaultCountry: state.auth.defaultCountry,
    loggedInUserId: state.auth.loggedInUserId,
    showMyCustomers: state.auth.showMyCustomers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(AddChildItemDialog));
